import { Icon } from '@/components/Icon';
import { openLink } from '@/utils/linkHelpers';
import { Pressable, View } from 'react-native';
import { Text } from '@/components/Text';
import theme from '@/config/theme';
import { styles } from './Kontakt.styles';

export const Kontakt = () => (
  <View style={styles.wrapper}>
    <View style={styles.headerRow}>
      <Text style={styles.headerText}>
        Verfügbarkeit: Mo-Fr 08:00 - 15:00 Uhr
      </Text>
    </View>
    <View style={styles.buttonsRow}>
      <Pressable
        style={styles.buttonLeft}
        onPress={() => openLink('mailto:info@neolexon.de')}
      >
        <View style={styles.buttonContent}>
          <Icon
            name="envelope"
            size={theme.fontSizes['3xl']}
            color={theme.colors.primary}
            style={styles.iconMargin}
          />
          <Text style={styles.buttonText}>info@neolexon.de</Text>
        </View>
      </Pressable>
      <Pressable
        style={styles.button}
        onPress={() => openLink('tel:+49 (0)89 24886 4440')}
      >
        <View style={styles.buttonContent}>
          <Icon
            name="phone"
            size={theme.fontSizes['3xl']}
            color={theme.colors.primary}
            style={styles.iconMargin}
          />
          <Text style={styles.buttonText}>+49 (0)89 24886 4440</Text>
        </View>
      </Pressable>
    </View>
  </View>
);
